$(document).ready(function(){
  function _init(){
    cacheDom()
    // render()
  }
  function cacheDom(){
    
    const urlParams = new URLSearchParams(window.location.search);

    // Get the value of a specific parameter, e.g., 'param1'
    // const param1Value = urlParams.get('filter');
    
    // console.log(param1Value);
    // let filter= $(`.search-filter-popup [href="${param1Value}"]`)
    // if(filter){
    //   $(".search-filter-popup .filter-name").removeClass("filter-active")
    //   let spactive = $(filter).addClass("filter-active")
    // }
    let active_link = null
    const m = urlParams.get('m');
    if(m=='category' || $(`.site-nav--current > a`).length == 0){
      $(".search-filter-popup .filter-name").removeClass("filter-active")
      
      let search = new URLSearchParams(window.location.search)
      
      const index = search.get('index')
      active_link = $(`.search-filter-popup li[data-index="${index}"]`)
      active_link.addClass("filter-active")
    }
    
    if(!active_link || $(`.site-nav--current > a`).length == 0){
      let collection_link = window.location.pathname
      active_link = $(`.search-filter-popup a[href="${collection_link}"]`).parent()
    
      //if theres active link
      if(active_link.length > 0){
        active_link.addClass('filter-active')
      }
    }
    // $(".search-filter-popup .filter-list:has(.filter-active) > span.icon").trigger('click')
    // $(".search-filter-popup .filter-list.filter-active > span.icon").trigger('click')
  }
  // function render(){
  //   // loadJSONcollection('/collections/hot-products')
  // }

  let height = $('.site-navigation').height()
  $('.search-filter-popup .wrapper').css('padding-top',(parseInt(height)+90)+'px')
  

  $('.btn--searcher-filter').click(function(){
    if($('.search-filter-popup').height() ==0){
      let nav_height = $('.site-navigation').height()
      let bottom_gap = 80
      if($('.mobile-nav').css('display')=='block'){
        setTimeout(function(){
          nav_height = $('.site-navigation').height()
          $('.search-filter-popup').css({'top':`${nav_height}px`,'height':`calc(100% - ${nav_height+bottom_gap}px`});
        },220)
      }else{
        $('.search-filter-popup').css({'top':`${nav_height}px`,'height':`calc(100% - ${nav_height+bottom_gap}px`});

      }
      $('body').css({'height':'auto','overflow-y':'hidden'})
      $('.site-dark-overlay-mobile').fadeIn(200)
      theme.Header.prototype.menuClose()
    }else{
      $('.search-filter-popup').css({'height':'0'});
      $('body').css({'height':'unset','overflow-y':'unset'})
      $('.site-dark-overlay-mobile').fadeOut(200)
    }
    // $('.mobile-nav-trigger .icon').click()
  })

  $('.site-dark-overlay-mobile').on('click', function () {
    $('.search-filter-popup').css({'height':'0'});
    $('body').css({'height':'unset','overflow-y':'unset'})
    $('.site-dark-overlay-mobile').fadeOut(200)
  })



  $(".search-filter-popup .filter-list span.icon, .search-filter-popup .filter-list .filter-name").click(function(){
    if($(this).parent().find('> span.icon').attr("aria-hidden")=="false"){
      $(this).parent().find('> span.icon').attr("aria-hidden","true")
      $(this).parent().find('> .filter-category').hide()
      $(this).parent().find('> span.icon').css("transform","rotate(0deg)")
    }else{
      $(this).parent().find('> span.icon').attr("aria-hidden","false")
      $(this).parent().find('> .filter-category').show()
      $(this).parent().find('> span.icon').css("transform","rotate(180deg)")
    }
  })
  
  let dataurl = "/collections/new-products"
  let datasort = "manual"
  $(".search-filter-popup .filter-name").click(function(e){
    e.preventDefault()
    // dataurl = $(this).attr("data-url")
    dataurl = $(this).attr("href")
    // loadJSONcollection(dataurl,datasort)
    $(".search-filter-popup .filter-name").removeClass("filter-active")
    $(this).addClass("filter-active")
    $(".custom-filter-section .new-selling")
    $('.search-filter-popup .header h2').text($(this).find('> span:first-child').text())
    window.location.href = "/?filter="+dataurl+"#filter"
  })

  // $(".search-filter-popup .sort-products").change(function(){
  //   datasort= $(this).val()
  //   // loadJSONcollection(dataurl,datasort)
  // })


  // function loadJSONcollection(url,sort="manual") {

  //   $('.search-filter-popup .pagination-container').pagination({
  //       pageSize:9,
  //       showSizeChanger: true,
  //       sizeChangerOptions:[9,12,15,18,22], 
  //     showNavigator: true,
  //     formatNavigator: '<%= rangeStart %>-<%= rangeEnd %> of <%= totalNumber %> items',
  //       dataSource:function(done){
  //         $.ajax({
  //             url:	`${url}?view=search&sort_by=${sort}`,
  //             type:	'GET'
  //         })
  //         .success(function(data) {
  //           dd = data
  //           console.log(dd)
  //           done(JSON.parse(dd.replaceAll("\t","")).results)             
  //         })
  //         .fail(function(data) {console.log(data)})


  //       },
  //       callback: function(data, pagination) {
  //           // template method of yourself
  //           // var html = template(data);
          
  //           // $('.search-filter-popup .product-grid-container').html(html);
  //       }
  //   })
  // 	console.log("triggered");
  	
  // }

  // function template(data){
  //   console.log(data)
  //   let html_content=""
  //   data.forEach(e => {
  //     html_content += e
  //   })
  //     $('.product-grid-container .grid-uniform').html(html_content)
  // }

  _init();

  
})
